import { ArgsInitSliceMeta, ReferenceOfMeta } from '@vs/rtk/utils';

export const referenceOfMeta: ReferenceOfMeta = {
  _deployEnv: undefined,
  _baseUrl: undefined,
  _ssoBaseUrl: undefined,
  _getTokenFunc: undefined,
  _getUserIdFunc: undefined,
};

export function initSliceMeta({
  deployEnv,
  baseUrl,
  ssoBaseUrl,
  getTokenFunc,
  getUserIdFunc,
}: ArgsInitSliceMeta) {
  referenceOfMeta._deployEnv = deployEnv;
  referenceOfMeta._baseUrl = baseUrl;
  referenceOfMeta._ssoBaseUrl = ssoBaseUrl;
  referenceOfMeta._getTokenFunc = getTokenFunc;
  referenceOfMeta._getUserIdFunc = getUserIdFunc;
}
